export const iconoLogo = {
  src: "/logo/icon.png",
  alt: "Logo de Mainfud By Seventwo",
};

export const logo = {
  src: "/logo/logo.png",
  alt: "Logo de Mainfud By Seventwo",
};
